import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class OctTypeService {
    private headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private octTypeUrl = 'api/octType';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getOctTypeList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        return this.http
            .get(this.octTypeUrl + '/getOctTypeList', options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addUpdateOctType(data: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in data) {
            params.set(key.toString(), data[key]);
        }
        let body = params.toString();
        let options = new RequestOptions({ headers: this.headers });

        return this.http
            .post(this.octTypeUrl + '/addUpdateOctType', body, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteOctType(data: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in data) {
            params.set(key.toString(), data[key]);
        }
        let body = params.toString();
        let options = new RequestOptions({ headers: this.headers });

        return this.http
            .post(this.octTypeUrl + '/deleteOctType', body, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/octType.service.ts